module.exports = __webpack_public_path__ + "static/sport/in3.31f483d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/in3.jpg
// module id = xTDG
// module chunks = 0